import * as React from 'react'
import { AddCardButtonStyled } from './styles'

const AddCardButton = ({ onClick }) => <AddCardButtonStyled onClick={onClick}>+</AddCardButtonStyled>

export default AddCardButton
